import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=8601b0f0&scoped=true"
import script from "./Debug.vue?vue&type=script&setup=true&lang=js"
export * from "./Debug.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Debug.vue?vue&type=style&index=0&id=8601b0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8601b0f0",
  null
  
)

export default component.exports